<template>
	<div>
		<!-- Header Component -->
		<Header></Header>

		<div class="pa-container">
			<!-- Router View -->
			<router-view :key="$route.fullPath"></router-view>

			<v-footer padless>
				<v-card flat color="#005DB9" tile>
					<v-card-text>
						<v-row justify="center">
							<v-col
								cols="12"
								md="10"
								lg="8"
								class="d-flex flex-column white--text text-center align-center justify-center"
							>
								<img
									src="http://apps.pinturasacuario.mx/assets/logo-blanco-transparente.png"
									alt=""
									width="75px"
								/>

								<div class="mb-5 mt-4">
									<v-btn
										class="mx-4 white--text"
										icon
										title="Facebook"
										target="blank"
										href="https://www.facebook.com/PinturasAcuarioOficial"
									>
										<v-icon size="24px">
											mdi-facebook
										</v-icon>
									</v-btn>
									<v-btn
										class="mx-4 white--text"
										icon
										title="Instagram"
										target="blank"
										href="https://www.instagram.com/pinturasacuario"
									>
										<v-icon size="24px">
											mdi-instagram
										</v-icon>
									</v-btn>
									<v-btn
										class="mx-4 white--text"
										icon
										title="YouTube"
										target="blank"
										href="https://www.youtube.com/channel/UC0rIvyVx90d-iwgfiKPDwFQ"
									>
										<v-icon size="24px">
											mdi-youtube
										</v-icon>
									</v-btn>
									<v-btn
										class="mx-4 white--text"
										icon
										title="Twitter"
										target="blank"
										href="https://twitter.com/pint_acuario"
									>
										<v-icon size="24px">
											mdi-twitter
										</v-icon>
									</v-btn>
								</div>

								<p class="text-center">
									Lorem ipsum dolor, sit, amet consectetur
									adipisicing elit. Nisi dignissimos ab
									maiores magni molestias expedita ut
									laudantium nulla enim aspernatur! Non
									libero, facilis nisi, assumenda quos
									explicabo quasi odio ab aut reprehenderit in
									voluptate. Dignissimos vero, enim. Nulla
									libero expedita aspernatur quidem corrupti,
									minima illo enim aliquam placeat, cum
									dolorum.
								</p>
							</v-col>
						</v-row>
					</v-card-text>

					<v-divider></v-divider>

					<v-card-text class="white--text text-center">
						{{
							`Pinturas Acuario&#174; - ${new Date().getFullYear()} - Todos los derechos reservados.`
						}}
					</v-card-text>
				</v-card>
			</v-footer>
		</div>

		<!-- CartTypePanelComponent -->
		<CartTypePanel></CartTypePanel>
	</div>
</template>

<script>
import Header from "@/components/Header";
import NavBar from "@/components/NavBar";
import CartTypePanel from "@/components/Cart/CartTypePanel";

export default {
	name: "Store",

	components: {
		NavBar,
		Header,
		CartTypePanel,
	},

	data() {
		return {};
	},

	mounted() {
		this.$store.dispatch("getCategories");
	},
};
</script>

<style lang="css">
*::-webkit-scrollbar-track {
	background-color: rgba(0, 0, 0, 0.1);
}

*::-webkit-scrollbar {
	width: 6px;
	height: 6px;
	background-color: transparent;
}

*::-webkit-scrollbar-thumb {
	background-color: #005db9;
}

.v-list-item__mask {
	background-color: red !important;
}

.v-list-item__mask {
	background-color: #1976d2 !important;
	color: #fff !important;
}

.v-select__slot input {
	padding: 0 !important;
	margin: 0 !important;
}
</style>
